// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ─────────────────────────────────────────────────────────────
   Button · 3 sizes × 6 variants
   ───────────────────────────────────────────────────────────── */

.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-family: var(--sans);
  font-weight: 500;
  border: 1px solid transparent;
  border-radius: var(--r-data);
  cursor: pointer;
  letter-spacing: -0.01em;
  text-decoration: none;
  transition:
    background 0.1s,
    border-color 0.1s,
    box-shadow 0.1s;
  white-space: nowrap;
  font-feature-settings: 'ss01';
  line-height: 1;
}

.btn:focus-visible {
  outline: none;
  box-shadow: var(--focus-ring);
}

.btn:disabled,
.btn.disabled {
  cursor: not-allowed;
  opacity: 0.55;
  pointer-events: none;
}

/* ── Sizes ── */
.btn-sm {
  height: 28px;
  padding: 0 12px;
  font-size: var(--fs-meta);
}
.btn-md {
  height: 36px;
  padding: 0 16px;
  font-size: var(--fs-ui);
}
.btn-lg {
  height: 44px;
  padding: 0 22px;
  font-size: var(--fs-note);
}

.btn-full {
  width: 100%;
}

/* ── Primary · solid blue ── */
.btn-primary {
  background: var(--signal);
  color: #ffffff;
  border-color: var(--signal);
  box-shadow:
    0 1px 0 rgba(9, 87, 200, 0.3),
    inset 0 1px 0 rgba(255, 255, 255, 0.16);
}
.btn-primary:hover {
  background: var(--signal-deep);
  border-color: var(--signal-deep);
}
.btn-primary:active {
  background: #07419a;
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.2);
}

/* ── Seal · ink-dark + cream brand-signature ── */
.btn-seal {
  background: var(--ink-dark);
  color: var(--cream);
  border-color: var(--ink-dark);
  box-shadow:
    0 1px 0 rgba(0, 0, 0, 0.3),
    inset 0 0 0 1px rgba(242, 227, 181, 0.16);
}
.btn-seal:hover {
  background: #060e22;
  border-color: #060e22;
}
.btn-seal:active {
  background: #03081a;
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.4);
}
[data-theme='dark'] .btn-seal {
  background: var(--cream);
  color: var(--ink-dark);
  border-color: var(--cream);
  box-shadow:
    0 1px 0 rgba(0, 0, 0, 0.3),
    inset 0 0 0 1px rgba(10, 22, 51, 0.1);
}
[data-theme='dark'] .btn-seal:hover {
  background: #fff1c9;
  border-color: #fff1c9;
}

/* ── Secondary · outlined ink ── */
.btn-secondary {
  background: var(--bg-alt);
  color: var(--text);
  border-color: var(--text-secondary);
}
.btn-secondary:hover {
  background: var(--bg);
  border-color: var(--text);
}
[data-theme='dark'] .btn-secondary {
  background: var(--ink-dark-2);
  color: var(--ink-text);
  border-color: var(--ink-text-2);
}
[data-theme='dark'] .btn-secondary:hover {
  background: var(--ink-dark);
  border-color: var(--ink-text);
}

/* ── Ghost · transparent cancel-class ── */
.btn-ghost {
  background: transparent;
  color: var(--text-secondary);
  border-color: transparent;
}
.btn-ghost:hover {
  background: var(--bg-alt);
  color: var(--text);
}
[data-theme='dark'] .btn-ghost {
  color: var(--ink-text-2);
}
[data-theme='dark'] .btn-ghost:hover {
  background: var(--ink-dark-2);
  color: var(--ink-text);
}

/* ── Danger outlined ── */
.btn-danger {
  background: transparent;
  color: var(--danger);
  border-color: rgba(180, 35, 24, 0.45);
}
.btn-danger:hover {
  background: var(--err-bg);
  border-color: var(--danger);
}
[data-theme='dark'] .btn-danger {
  color: #f2887e;
  border-color: rgba(242, 136, 126, 0.45);
}
[data-theme='dark'] .btn-danger:hover {
  background: rgba(180, 35, 24, 0.16);
  border-color: #f2887e;
}

/* ── Danger solid · final destructive confirmation ── */
.btn-danger-solid {
  background: var(--danger);
  color: #ffffff;
  border-color: var(--danger);
  box-shadow:
    0 1px 0 rgba(140, 25, 18, 0.3),
    inset 0 1px 0 rgba(255, 255, 255, 0.14);
}
.btn-danger-solid:hover {
  background: #93180d;
  border-color: #93180d;
}

/* ── Glyph slots ── */
.btn .gly {
  font-family: var(--mono);
  line-height: 1;
  opacity: 0.9;
}
.btn-lg .gly {
  font-size: var(--fs-md);
}
.btn-md .gly {
  font-size: var(--fs-note);
}
.btn-sm .gly {
  font-size: var(--fs-meta);
}

/* ── Kbd hints ── */
.btn .kbd-hint {
  font-family: var(--mono);
  font-size: var(--fs-micro);
  background: rgba(255, 255, 255, 0.18);
  border: 1px solid rgba(255, 255, 255, 0.22);
  border-radius: 2px;
  padding: 2px 5px;
  margin-left: 2px;
}
.btn-secondary .kbd-hint,
.btn-ghost .kbd-hint {
  background: var(--bg);
  border-color: var(--border);
  color: var(--text-muted);
}
[data-theme='dark'] .btn-secondary .kbd-hint,
[data-theme='dark'] .btn-ghost .kbd-hint {
  background: var(--ink-dark);
  border-color: var(--ink-rule);
  color: var(--ink-text-3);
}
.btn-seal .kbd-hint {
  background: rgba(242, 227, 181, 0.16);
  border-color: rgba(242, 227, 181, 0.3);
}
[data-theme='dark'] .btn-seal .kbd-hint {
  background: rgba(10, 22, 51, 0.14);
  border-color: rgba(10, 22, 51, 0.22);
}
.btn-danger .kbd-hint {
  background: rgba(180, 35, 24, 0.1);
  border-color: rgba(180, 35, 24, 0.22);
  color: var(--danger);
}
[data-theme='dark'] .btn-danger .kbd-hint {
  background: rgba(242, 136, 126, 0.12);
  border-color: rgba(242, 136, 126, 0.25);
  color: #f2887e;
}
`, "",{"version":3,"sources":["webpack://./src/ui/Button/Button.css"],"names":[],"mappings":"AAAA;;kEAEkE;;AAElE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,wBAAwB;EACxB,gBAAgB;EAChB,6BAA6B;EAC7B,4BAA4B;EAC5B,eAAe;EACf,uBAAuB;EACvB,qBAAqB;EACrB;;;mBAGiB;EACjB,mBAAmB;EACnB,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,6BAA6B;AAC/B;;AAEA;;EAEE,mBAAmB;EACnB,aAAa;EACb,oBAAoB;AACtB;;AAEA,gBAAgB;AAChB;EACE,YAAY;EACZ,eAAe;EACf,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,eAAe;EACf,uBAAuB;AACzB;AACA;EACE,YAAY;EACZ,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA,+BAA+B;AAC/B;EACE,yBAAyB;EACzB,cAAc;EACd,2BAA2B;EAC3B;;2CAEyC;AAC3C;AACA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;AACA;EACE,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA,kDAAkD;AAClD;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,6BAA6B;EAC7B;;6CAE2C;AAC7C;AACA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,8CAA8C;AAChD;AACA;EACE,wBAAwB;EACxB,sBAAsB;EACtB,0BAA0B;EAC1B;;yCAEuC;AACzC;AACA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,mCAAmC;AACnC;EACE,yBAAyB;EACzB,kBAAkB;EAClB,mCAAmC;AACrC;AACA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;AACA;EACE,6BAA6B;EAC7B,sBAAsB;EACtB,+BAA+B;AACjC;AACA;EACE,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA,2CAA2C;AAC3C;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA,0BAA0B;AAC1B;EACE,uBAAuB;EACvB,oBAAoB;EACpB,qCAAqC;AACvC;AACA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;AACA;EACE,cAAc;EACd,uCAAuC;AACzC;AACA;EACE,mCAAmC;EACnC,qBAAqB;AACvB;;AAEA,wDAAwD;AACxD;EACE,yBAAyB;EACzB,cAAc;EACd,2BAA2B;EAC3B;;2CAEyC;AAC3C;AACA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,sBAAsB;AACtB;EACE,wBAAwB;EACxB,cAAc;EACd,YAAY;AACd;AACA;EACE,uBAAuB;AACzB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;;AAEA,oBAAoB;AACpB;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,qCAAqC;EACrC,2CAA2C;EAC3C,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;;EAEE,qBAAqB;EACrB,2BAA2B;EAC3B,wBAAwB;AAC1B;AACA;;EAEE,2BAA2B;EAC3B,6BAA6B;EAC7B,wBAAwB;AAC1B;AACA;EACE,qCAAqC;EACrC,sCAAsC;AACxC;AACA;EACE,kCAAkC;EAClC,oCAAoC;AACtC;AACA;EACE,kCAAkC;EAClC,qCAAqC;EACrC,oBAAoB;AACtB;AACA;EACE,qCAAqC;EACrC,uCAAuC;EACvC,cAAc;AAChB","sourcesContent":["/* ─────────────────────────────────────────────────────────────\n   Button · 3 sizes × 6 variants\n   ───────────────────────────────────────────────────────────── */\n\n.btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  font-family: var(--sans);\n  font-weight: 500;\n  border: 1px solid transparent;\n  border-radius: var(--r-data);\n  cursor: pointer;\n  letter-spacing: -0.01em;\n  text-decoration: none;\n  transition:\n    background 0.1s,\n    border-color 0.1s,\n    box-shadow 0.1s;\n  white-space: nowrap;\n  font-feature-settings: 'ss01';\n  line-height: 1;\n}\n\n.btn:focus-visible {\n  outline: none;\n  box-shadow: var(--focus-ring);\n}\n\n.btn:disabled,\n.btn.disabled {\n  cursor: not-allowed;\n  opacity: 0.55;\n  pointer-events: none;\n}\n\n/* ── Sizes ── */\n.btn-sm {\n  height: 28px;\n  padding: 0 12px;\n  font-size: var(--fs-meta);\n}\n.btn-md {\n  height: 36px;\n  padding: 0 16px;\n  font-size: var(--fs-ui);\n}\n.btn-lg {\n  height: 44px;\n  padding: 0 22px;\n  font-size: var(--fs-note);\n}\n\n.btn-full {\n  width: 100%;\n}\n\n/* ── Primary · solid blue ── */\n.btn-primary {\n  background: var(--signal);\n  color: #ffffff;\n  border-color: var(--signal);\n  box-shadow:\n    0 1px 0 rgba(9, 87, 200, 0.3),\n    inset 0 1px 0 rgba(255, 255, 255, 0.16);\n}\n.btn-primary:hover {\n  background: var(--signal-deep);\n  border-color: var(--signal-deep);\n}\n.btn-primary:active {\n  background: #07419a;\n  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.2);\n}\n\n/* ── Seal · ink-dark + cream brand-signature ── */\n.btn-seal {\n  background: var(--ink-dark);\n  color: var(--cream);\n  border-color: var(--ink-dark);\n  box-shadow:\n    0 1px 0 rgba(0, 0, 0, 0.3),\n    inset 0 0 0 1px rgba(242, 227, 181, 0.16);\n}\n.btn-seal:hover {\n  background: #060e22;\n  border-color: #060e22;\n}\n.btn-seal:active {\n  background: #03081a;\n  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.4);\n}\n[data-theme='dark'] .btn-seal {\n  background: var(--cream);\n  color: var(--ink-dark);\n  border-color: var(--cream);\n  box-shadow:\n    0 1px 0 rgba(0, 0, 0, 0.3),\n    inset 0 0 0 1px rgba(10, 22, 51, 0.1);\n}\n[data-theme='dark'] .btn-seal:hover {\n  background: #fff1c9;\n  border-color: #fff1c9;\n}\n\n/* ── Secondary · outlined ink ── */\n.btn-secondary {\n  background: var(--bg-alt);\n  color: var(--text);\n  border-color: var(--text-secondary);\n}\n.btn-secondary:hover {\n  background: var(--bg);\n  border-color: var(--text);\n}\n[data-theme='dark'] .btn-secondary {\n  background: var(--ink-dark-2);\n  color: var(--ink-text);\n  border-color: var(--ink-text-2);\n}\n[data-theme='dark'] .btn-secondary:hover {\n  background: var(--ink-dark);\n  border-color: var(--ink-text);\n}\n\n/* ── Ghost · transparent cancel-class ── */\n.btn-ghost {\n  background: transparent;\n  color: var(--text-secondary);\n  border-color: transparent;\n}\n.btn-ghost:hover {\n  background: var(--bg-alt);\n  color: var(--text);\n}\n[data-theme='dark'] .btn-ghost {\n  color: var(--ink-text-2);\n}\n[data-theme='dark'] .btn-ghost:hover {\n  background: var(--ink-dark-2);\n  color: var(--ink-text);\n}\n\n/* ── Danger outlined ── */\n.btn-danger {\n  background: transparent;\n  color: var(--danger);\n  border-color: rgba(180, 35, 24, 0.45);\n}\n.btn-danger:hover {\n  background: var(--err-bg);\n  border-color: var(--danger);\n}\n[data-theme='dark'] .btn-danger {\n  color: #f2887e;\n  border-color: rgba(242, 136, 126, 0.45);\n}\n[data-theme='dark'] .btn-danger:hover {\n  background: rgba(180, 35, 24, 0.16);\n  border-color: #f2887e;\n}\n\n/* ── Danger solid · final destructive confirmation ── */\n.btn-danger-solid {\n  background: var(--danger);\n  color: #ffffff;\n  border-color: var(--danger);\n  box-shadow:\n    0 1px 0 rgba(140, 25, 18, 0.3),\n    inset 0 1px 0 rgba(255, 255, 255, 0.14);\n}\n.btn-danger-solid:hover {\n  background: #93180d;\n  border-color: #93180d;\n}\n\n/* ── Glyph slots ── */\n.btn .gly {\n  font-family: var(--mono);\n  line-height: 1;\n  opacity: 0.9;\n}\n.btn-lg .gly {\n  font-size: var(--fs-md);\n}\n.btn-md .gly {\n  font-size: var(--fs-note);\n}\n.btn-sm .gly {\n  font-size: var(--fs-meta);\n}\n\n/* ── Kbd hints ── */\n.btn .kbd-hint {\n  font-family: var(--mono);\n  font-size: var(--fs-micro);\n  background: rgba(255, 255, 255, 0.18);\n  border: 1px solid rgba(255, 255, 255, 0.22);\n  border-radius: 2px;\n  padding: 2px 5px;\n  margin-left: 2px;\n}\n.btn-secondary .kbd-hint,\n.btn-ghost .kbd-hint {\n  background: var(--bg);\n  border-color: var(--border);\n  color: var(--text-muted);\n}\n[data-theme='dark'] .btn-secondary .kbd-hint,\n[data-theme='dark'] .btn-ghost .kbd-hint {\n  background: var(--ink-dark);\n  border-color: var(--ink-rule);\n  color: var(--ink-text-3);\n}\n.btn-seal .kbd-hint {\n  background: rgba(242, 227, 181, 0.16);\n  border-color: rgba(242, 227, 181, 0.3);\n}\n[data-theme='dark'] .btn-seal .kbd-hint {\n  background: rgba(10, 22, 51, 0.14);\n  border-color: rgba(10, 22, 51, 0.22);\n}\n.btn-danger .kbd-hint {\n  background: rgba(180, 35, 24, 0.1);\n  border-color: rgba(180, 35, 24, 0.22);\n  color: var(--danger);\n}\n[data-theme='dark'] .btn-danger .kbd-hint {\n  background: rgba(242, 136, 126, 0.12);\n  border-color: rgba(242, 136, 126, 0.25);\n  color: #f2887e;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
